import React from "react";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ChatsContextProvider } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import {
  GroupChatsContextImport,
  GroupChatsContextProvider,
} from "../../../../provider/chats/chats/group_chats/GroupChatsContextProvider";

const ConversationGroupExitAlert = () => {
  return (
    <ChatsContextProvider>
      <GroupChatsContextProvider>
        <ConversationGroupExitAlertBody />
      </GroupChatsContextProvider>
    </ChatsContextProvider>
  );
};

export default ConversationGroupExitAlert;

const ConversationGroupExitAlertBody = () => {
  const { submitGroupExit } = GroupChatsContextImport();

  return (
    <Listing className="font-size-16_17 color-theme-label">
      <ListItem className="text-center">
        <div
          role="button"
          className="pb-1"
          onClick={() => submitGroupExit("1")}
        >
          {AppTranslation.text("exit_group")}
        </div>
      </ListItem>
      <ListItem className="text-center">
        <div
          role="button"
          className="pt-1"
          onClick={() => submitGroupExit("2")}
        >
          {AppTranslation.text("exit_and_delete_for_me")}
        </div>
      </ListItem>
    </Listing>
  );
};
